import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { applyDirection } from './locale';

// Locale is async-only (resolved from the native bridge in fetchAndApplyLocale).
// Start in the fallback; fetchAndApplyLocale() calls changeLanguage once data.get resolves.
const initialLng = 'en';

i18n.use(initReactI18next).init({
  lng: initialLng,
  fallbackLng: 'en',
  ns: ['translation'], // minimal base ns; modules register their own
  defaultNS: 'translation',
  resources: { en: { translation: {} } },
  keySeparator: false, // keys are literal English strings
  nsSeparator: false, // ...so ':' / '.' in copy don't split keys
  interpolation: { escapeValue: false }, // React already escapes
  returnEmptyString: false,
  react: { useSuspense: false }, // bundled resources resolve synchronously
  debug: false,
});

applyDirection(initialLng);
i18n.on('languageChanged', (lng) => applyDirection(lng));

export default i18n;
